import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
} from "@angular/core";
import { Router } from "@angular/router";
import { Platform, PopoverController } from "@ionic/angular";
import { AuthService, storageKeySSO } from "src/app/auth/auth.service";
import { GlobalDataService } from "src/app/services/global-data.service";

@Component({
  selector: "app-navigation-dropdown",
  templateUrl: "./navigation-dropdown.component.html",
  styleUrls: ["./navigation-dropdown.component.scss"],
})
export class NavigationDropdownComponent {
  filterByCategory;
  expandedCategory;
  isBrowser: boolean = false;
  cordova: boolean = false;

  @Input() data: any[];
  @Input() ssoProfile;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.dismissPopover();
  }

  constructor(
    private platform: Platform,
    private popoverController: PopoverController,
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.platform.ready().then(() => {
      this.cordova = this.platform.is("cordova");
    });
  }

  /**
   * Dismiss popover
   */
  async dismissPopover() {
    await this.popoverController.dismiss();
  }

  /**
   * Link to page dependant on slug
   */
  linkToPage(item) {
    let url = item.path;

    if (url === "logout") {
      this.authService.logOut();
      this.router.navigate(["/"]);
    } else {
      if (url.indexOf("/") < 0) url = "/page/" + item.path;

      if (item.newWindow && typeof window !== "undefined") {
        window.open(url, "_blank");
      } else {
        this.router.navigateByUrl(url);
      }
    }

    this.dismissPopover();
  }
}
